import api from './api';

class UserService {
  // Get all users with pagination and filtering
  static async getUsers(params = {}) {
    try {
      //console.log('=== UserService.getUsers START ===');
      //console.log('UserService.getUsers called with params:', params);
      //console.log('API base URL:', api.defaults.baseURL);
      //console.log('API headers:', api.defaults.headers);
      //console.log('Making API call to /users');
      
      const response = await api.get('/users', { params });
      
      //console.log('API response received:', response);
      //console.log('Response status:', response.status);
      //console.log('Response headers:', response.headers);
      //console.log('Response data:', response.data);
      //console.log('Response data type:', typeof response.data);
      //console.log('Response data keys:', Object.keys(response.data || {}));
      
      //console.log('=== UserService.getUsers END ===');
      return response.data;
    } catch (error) {
      console.error('=== UserService.getUsers ERROR ===');
      console.error('Error fetching users:', error);
      console.error('Error type:', typeof error);
      console.error('Error name:', error.name);
      console.error('Error message:', error.message);
      console.error('Error stack:', error.stack);
      console.error('Error response:', error.response);
      console.error('Error response status:', error.response?.status);
      console.error('Error response data:', error.response?.data);
      console.error('Error config:', error.config);
      console.error('=== UserService.getUsers ERROR END ===');
      throw error;
    }
  }

  // Get user by ID
  static async getUserById(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  }

  // Create new user
  static async createUser(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  }

  // Update user
  static async updateUser(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  }

  // Delete user
  static async deleteUser(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  }

  // Update user status
  static async updateUserStatus(id, status) {
    try {
      const response = await api.put(`/users/${id}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating user status:', error);
      throw error;
    }
  }

  // Get available roles
  static async getAvailableRoles() {
    try {
      const response = await api.get('/users/roles/available');
      return response.data;
    } catch (error) {
      console.error('Error fetching available roles:', error);
      throw error;
    }
  }

  // Get available departments
  static async getAvailableDepartments() {
    try {
      const response = await api.get('/users/departments/available');
      return response.data;
    } catch (error) {
      console.error('Error fetching available departments:', error);
      throw error;
    }
  }

  // Reset user password
  static async resetUserPassword(id) {
    try {
      const response = await api.post(`/users/${id}/reset-password`);
      return response.data;
    } catch (error) {
      console.error('Error resetting user password:', error);
      throw error;
    }
  }
}

export default UserService;
